import React, { useState, useEffect} from 'react';
import Sidebar from '../../components/sidebar/Sidebar';
import Topbar from '../../components/topbar/Topbar';
import ComponenteCalendario from '../../components/calendarioComponente/ComponenteCalendario';
import style from './calendarioAlunos.module.css'; 
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

const CalendarioAlunos = () => {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

    return (
       <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
                <div className={style.pagina_conteudo}>
                    <h4>Calendário</h4>
                    <ComponenteCalendario />
                </div>
            </Topbar>
        </Sidebar>
    );
};

export default CalendarioAlunos;